import Modal from "../../../../_components/Modal";
import { formatCurrencyValue } from "../../../../utils";
import TableData from "../../../../_components/TableData";
import React, { useEffect, useState } from "react";
export default function VisualizePurchaseModal(props) {
    const [items, setItems] = useState([])
    function mapItems() {
        let data
        data = props.item.items
        if(data){
        const items = data.map(item => ({
            ...item,
            price: formatCurrencyValue(item.price)
        }))
        setItems(items)
        }
    }

    function onHide(){
        if(props.onHide){
            props.onHide()
        }
    }
    useEffect(() => {
        mapItems()
    },[props.onShow])
    return (
        <Modal
            title="Visualizar compra"
            show={props.onShow}
            onHide={props.onHide}
            >
            
            <TableData
            tHead={["Nome","Código", "Preço", "Quantidade"]}
            tBodyKeys={["name", "code", "price", "quantity"]}
            data={items}>
            </TableData>
            
        </Modal>
    )
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Purchases/modals/VisualizePurchaseModal.jsx